import axios from "axios";

export const deleteVessel = async (vesselID: number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/Vessel/vessel?VesselID=${vesselID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
